import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import QuoteDisplay from "./components/QuoteDisplay";
import TopNav from "./components/TopNav";
import Home from "./components/Home";
import YouTubeFeed from "./components/YoutubeFeed";
import QuotesGame from "./components/QuotesGame";
import SelectLevelPage from "./components/SelectLevel";
import Footer from "./components/Footer";
import About from "./components/About";
import AddPhrase from "./components/AddPhrase";
import FeedbackForm from "./components/FeedbackForm";
import FeedbackSelect from "./components/FeedbackSelect";
import { GameProvider } from "./components/GameContext";
import Confetti from "react-confetti";
import { isKariBday } from "./utils/dateUtils";
import TrendingPage from "./components/trending/TrendingPage";
import AddToHomePage from "./components/AddToHomePage";
import VpnGuide from "./components/VpnGuide";
import VotingGuide from "./components/VotingGuide";
import GenerateTweet from "./components/GenerateTweet";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SopaDeLetras from "./components/Crossword";
import { VideoPlayerProvider } from "./components/VideoPlayerProvider";
import GlobalVideoPlayer from "./components/GlobalVideoPlayer";
import SelectGame from "./components/SelectGame";
import SelectContent from "./components/SelectContent";
import MomentosDivertidos from "./components/MomentosDivertidos";
import AdminVideoTags from "./components/AdminVideoTags";
import MagicBall from "./components/MagicBall";
import MessageWall from "./components/MessageWall";
import KarimeView from "./components/KarimeView";
import { AuthProvider } from "./components/AuthContext";
import AuthPage from "./components/AuthPage";
import Profile from "./components/Profile";
import MigrationPage from "./components/MigrationPage";
import Leaderboard from "./components/Leaderboard";
import ResetPasswordPage from "./components/ResetPasswordPage";

const App = () => {
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    if (isKariBday()) {
      setShowConfetti(true);
      const timer = setTimeout(() => setShowConfetti(false), 10000);
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <BrowserRouter>
      <AuthProvider>
        <GameProvider>
          <VideoPlayerProvider>
            <div className="min-h-screen bg-gray-50 flex justify-center">
              <div className="w-full max-w-[500px] bg-white min-h-screen relative shadow-lg flex flex-col">
                <TopNav />

                {showConfetti && (
                  <Confetti
                    width={window.innerWidth}
                    height={window.innerHeight}
                    numberOfPieces={200}
                    recycle={false}
                    style={{ zIndex: 9999, position: "fixed", top: 0, left: 0 }}
                  />
                )}

                <div className="flex-1 overflow-auto bg-custom-gray">
                  <Routes>
                    <Route path="/home" element={<Home />} />
                    <Route path="/quotes" element={<QuoteDisplay />} />
                    <Route path="/youtube" element={<YouTubeFeed />} />
                    <Route path="/select-level" element={<SelectLevelPage />} />
                    <Route path="/game" element={<QuotesGame />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/add-phrase" element={<AddPhrase />} />
                    <Route path="/feedback" element={<FeedbackSelect />} />
                    <Route
                      path="/feedback/bug"
                      element={<FeedbackForm formType="bug" />}
                    />
                    <Route
                      path="/feedback/sugerencia"
                      element={<FeedbackForm formType="feedback" />}
                    />
                    <Route path="/tendencia" element={<TrendingPage />} />
                    <Route path="/como-agregar" element={<AddToHomePage />} />
                    <Route path="/ayuda-vpn" element={<VpnGuide />} />
                    <Route path="/ayuda-votacion" element={<VotingGuide />} />
                    <Route path="/generate-tweet" element={<GenerateTweet />} />
                    <Route path="/sopa-de-letras" element={<SopaDeLetras />} />
                    <Route path="/select-game" element={<SelectGame />} />
                    <Route path="/contenido" element={<SelectContent />} />
                    <Route
                      path="/momentos-divertidos"
                      element={<MomentosDivertidos />}
                    />
                    <Route path="/bola-magica" element={<MagicBall />} />
                    <Route path="/admin/videos" element={<AdminVideoTags />} />
                    {/* <Route path="/mensajes" element={<MessageWall />} />
                    <Route path="/para-karime" element={<KarimeView />} /> */}
                    <Route path="/perfil" element={<Profile />} />
                    <Route path="/login" element={<AuthPage />} />
                    <Route path="/migrar" element={<MigrationPage />} />
                    <Route path="/leaderboard" element={<Leaderboard />} />
                    <Route
                      path="/reset-password"
                      element={<ResetPasswordPage />}
                    />

                    <Route path="/" element={<Navigate to="/home" replace />} />
                  </Routes>
                </div>

                <ToastContainer
                  position="top-center"
                  autoClose={3000}
                  hideProgressBar
                  closeOnClick
                  pauseOnHover={false}
                  draggable={false}
                  toastClassName="!bg-[#FDE2F3] !text-[#8B005D] !font-quicksand !font-bold !rounded-xl !border !border-[#FBC0E0] !shadow-md"
                  bodyClassName="text-sm px-2 py-1"
                />

                <Footer />
              </div>

              {/* Mini‑player flotante y draggable fuera del contenedor estrecho */}
              <GlobalVideoPlayer />
            </div>
          </VideoPlayerProvider>
        </GameProvider>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default App;
